module.exports = __webpack_public_path__ + "static/p8-895364b3c3395d92c36b1a9b6a98d9b6.jpg";